<template>
  <div class="product-link">
    <div class="product-link-top">
      Reporting
      <div class="product-export" @click="exportReporting">
        <Icon name="daochu" class="product-export-icon" />
        <span>Export Reporting</span>
      </div>
    </div>
    <!-- <div class="mid-filter">
      <div class="mid-filter-item">
        <div class="mid-filter-title">Deals</div>
        <div class="mid-filter-checkbox">
          <a-checkbox v-model:checked="filter.activeDeals" @change="setFilter">Active</a-checkbox>
          <a-checkbox v-model:checked="filter.upcomingDeals" @change="setFilter"
            class="upcoming-box">Upcoming</a-checkbox>
        </div>
      </div>
    </div> -->
    <div class="table-wrapper">
      <artmisads-table :columns="publisherColumns" :data-source="publisherRows" :change="onTableChange" :pagination="{
        total: pagination.total,
        current: pagination.current,
        pageSize: pagination.pageSize,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50']
      }" :loading="publisherListLoading"  class="publisher-table">
        <template #bodyCell="{ column, record, text }">
          <template v-if="column.key === 'product'">
            <div class="product-info">
              <LogoImage :logoUrl="record.imageUrl" :brandName="record.brandName" />
              <div class="product-info-text">
                <a-tooltip :title="record.productTitle || undefined" placement="topLeft">
                  <div class="product-title">{{ record.productTitle }}</div>
                </a-tooltip>
                <div class="product-asin">{{ record.asin }}</div>
              </div>
            </div>
          </template>
          <template v-if="column.key === 'clicks'">
            <div class="info-item">
              <div class="info-item-row">
                <div class="item">
                  <img src="../../../../assets/images/img/AT@2x.png" alt="" class="icon" />
                  <span class="item-text">Attribution</span>
                </div>
                <div class="info-item-row-value">
                  {{ record.attributionClicks }}
                </div>
              </div>
              <div class="info-item-row">
                <div class="item">
                  <img src="../../../../assets/images/img/AS@2x.png" alt="" class="icon" />
                  <span class="item-text">Associate
                  </span>
                </div>
                <div class="info-item-row-value">
                  {{ record.associateClicks }}
                </div>
              </div>
            </div>
          </template>
          <template v-if="column.key === 'sales'">
            <div class="info-item">
              <div class="info-item-row">
                <div class="item">
                  <img src="../../../../assets/images/img/AT@2x.png" alt="" class="icon" />
                  <span class="item-text">Attribution</span>
                </div>
                <div class="info-item-row-value">
                  {{ record.currencySymbol }}{{ record.attributionSalesAmount }}
                </div>
              </div>
              <div class="info-item-row">
                <div class="item">
                  <img src="../../../../assets/images/img/AS@2x.png" alt="" class="icon" />
                  <span class="item-text">Associate
                  </span>
                </div>
                <div class="info-item-row-value">
                  {{ record.currencySymbol }}{{ record.associateSalesAmount }}
                </div>
              </div>
            </div>
          </template>
          <template v-if="column.key === 'budgetEarned'">
            {{ record.currencySymbol }}{{ record.budgetEarned }}
          </template>
        </template>
      </artmisads-table>
    </div>
  </div>
</template>
<script setup>
import Icon from '@/components/Icon.vue'
import { cpcCampaignsApi } from '~/server'
import { useRoute } from 'vue-router'
import { ref, onMounted } from 'vue'
import LogoImage from '@/components/LogoImage.vue'

const route = useRoute()
const campaignId = route.params.id


const pagination = ref({
  current: 1,
  pageSize: 10,
  total: 0,
})


const publisherColumns = ref([
  {
    title: 'Product',
    key: 'product',
    width: 400,
  },
  {
    title: 'Brand',
    key: 'brandName',
    dataIndex: 'brandName',
    width: 300,
  },
  
  {
    title: 'Clicks',
    key: 'clicks',
    width: 400,
  },
  {
    title: 'Sales',
    key: 'sales',
    width: 300,
  },
  {
    title: 'BudgetEarned',
    key: 'budgetEarned',
    width: 100,
  }
])
const publisherRows = ref([])
const publisherListLoading = ref(true)

const getProductLinkList = async () => {
  publisherListLoading.value = true

  const { data } = await cpcCampaignsApi.getJoinedReporting(
    { 
      campaignId: campaignId,
      page:pagination.value.current,
      size: pagination.value.pageSize,
    })
  publisherRows.value = data.data
  pagination.value.total = data.total
  publisherListLoading.value = false
}
const exportReporting = async () => {
  await cpcCampaignsApi.exportCampaigns('Reporting', { campaignId: campaignId })
}
const onTableChange = (pag) => {
  if (!pag) return
  pagination.value.current = pag.current ?? pagination.value.current
  pagination.value.pageSize = pag.pageSize ?? pagination.value.pageSize
  if (pag.total != null) {
    pagination.value.total = pag.total
  }
  getProductLinkList()
}
onMounted(() => {
  getProductLinkList()
})
</script>
<style scoped lang="less">
.product-link {
  .link-cell {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    width: 400px;
    max-width: 400px;
  }
  .link-text {
    display: block;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .copy-icon {
    flex-shrink: 0;
    cursor: pointer;
  }
  .icon-gengxin{
    flex-shrink: 0;
    cursor: pointer;
  }
  .deal-empty {
  color: #9ca3af;
}
  .product-info {
    display: flex;
    align-items: center;
    gap: 10px;
    max-width: 400px;

    .product-info-text {
      min-width: 0;
      flex: 1;

      .product-title {
        font-family: Sora;
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        letter-spacing: 0.4px;
        text-decoration: underline;
        text-decoration-style: solid;
        color: rgba(15, 6, 41, 1);
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        overflow: hidden;
        word-break: break-word;
      }

      .product-asin {
        font-family: Sora;
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0.3px;
        color: rgba(15, 6, 41, 0.5);
      }
    }

  }

  .mid-filter {
    display: flex;
    align-items: space-between;
    position: relative;
    margin-bottom: 16px;
    margin-top: 16px;
    // justify-content: space-between;
    padding: 16px;
    padding-right: 96px;
    border-radius: 8px;
    background-color: var(--bg-gray-1);
    flex-wrap: wrap;
    gap: 16px; // 垂直和水平间距都是16px
    // overflow: hidden;
    max-height: 86px; // 限制为一行的高度，不包括gap，因为第一行不会有gap
    transition: max-height 0.3s ease;

    &.expanded {
      max-height: none; // 展开时移除高度限制
      overflow: visible;
    }

    &-item {
      display: flex;
      flex-direction: column;
      // width: 20%;

      &.filter-item-hidden {
        display: none !important;
      }
    }

    //  &-item:first-child{
    //  width: 20%;
    //  }
    //  &-item:nth-child(2){
    //   width: 14%;
    //  }
    &-checkbox {
      background-color: var(--bg-gray-6);
      border-radius: 8px;
      height: 32px;
      padding: 0 8px;
      display: flex;
      align-items: center;
      // justify-content: center;
    }

    &-title {
      font-size: 13px;
      font-weight: 600;
      height: 18px;
      // opacity: 0.7;
      letter-spacing: 0.3px;
      line-height: 18px;
      color: #0f0629;
      margin-bottom: 4px;
    }
  }

  .product-link-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: Sora;
    font-weight: 600;
    font-size: 20px;
    padding: 22px 16px;
    letter-spacing: 0.4px;
    color: rgba(15, 6, 41, 1);
    border-bottom: 1px solid rgba(232, 229, 237, 1);
  }

  .product-export {
    display: flex;
    align-items: center;
    border-radius: 8px;
    background-color: rgba(114, 64, 255, 0.14);
    padding: 6px 16px;
    gap: 8px;
    cursor: pointer;

    .product-export-icon {
      width: 16px;
      height: 16px;
      color: rgba(15, 6, 41, 1);
    }

    >span {
      font-family: Sora;
      font-weight: 500;
      font-style: Medium;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.4px;
      color: rgba(15, 6, 41, 1);
    }
  }
}
.info-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .item {
  display: flex;
  padding: 3px 4px;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  background: #f1f0f5;
  min-width: 111px;

  .icon {
    width: 20px !important;
    height: 20px !important;
  }

  .item-text {
    color: #0f0629;
    font-family: 'Sora';
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.3px;
    opacity: 0.7;
  }
}
  .info-item-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .info-item-row-value {
    font-family: Sora;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 19px;
    letter-spacing: 0px;
    text-transform: uppercase;
    color: rgba(15, 6, 41, 1);
  }

}
</style>